import React, { useState } from "react";
import Onboarding from "./Onboarding";

const Signup = ({ onSignupComplete }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSignedUp, setIsSignedUp] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email.trim());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    if (password.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setIsLoading(true);

    try {
      // Validate hardcoded test credentials
      if (email === "test@test.com" && password === "password") {
        localStorage.setItem("token", "test-token"); // Simulated token
        setSuccess(`Welcome, ${email}! Redirecting to your dashboard...`);
        setIsSignedUp(true);
        return;
      }

      const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8080";
      console.log("Using API URL signup:", apiUrl);

      // Send signup request to the backend
      const response = await fetch(`${apiUrl}/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: email, password }),
      });

      if (response.ok) {
        const data = await response.json();
        const { access_token } = data;

        // Save token and proceed to onboarding
        localStorage.setItem("token", access_token);
        localStorage.setItem("isLoggedIn", "true"); // Set auth state
        setSuccess(`Welcome, ${email}! Redirecting to your dashboard...`);
        setIsSignedUp(true);
          // Trigger the callback
        if (onSignupComplete) {
          onSignupComplete(); // Tell the parent component that signup is complete
        } else {
          console.error("onSignupComplete is not defined!");
        }
      } else {
        const errorData = await response.json();
        setError(errorData.detail || "Signup failed. Please try again.");
      }
    } catch (err) {
      setError("An error occurred while signing up. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Signup</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          placeholder="Enter your email"
          aria-label="Email"
          required
        />
        <label style={styles.label}>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          placeholder="Enter your password"
          aria-label="Password"
          required
        />
        <label style={styles.label}>Confirm Password:</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          style={styles.input}
          placeholder="Confirm your password"
          aria-label="Confirm Password"
          required
        />
        <button type="submit" style={styles.button} disabled={isLoading}>
          {isLoading ? "Signing up..." : "Signup"}
        </button>
      </form>
      {error && <p style={styles.error}>{error}</p>}
      {success && <p style={styles.success}>{success}</p>}
    </div>
  );
};

export default Signup;

const styles = {
  container: {
    maxWidth: "400px",
    margin: "50px auto",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    marginBottom: "20px",
    color: "#333",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    textAlign: "left",
    marginBottom: "5px",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#555",
  },
  input: {
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  button: {
    padding: "10px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
  },
  error: {
    color: "red",
    marginTop: "10px",
    fontSize: "14px",
  },
  success: {
    color: "green",
    marginTop: "10px",
    fontSize: "14px",
  },
};
